import styled from 'styled-components';

import { mediaQueries } from '@/shared/constants';

export const Content = styled.div`
  flex-grow: 1;
  flex-direction: row;
  background: ${({ theme }) => theme.tokens.colors.neutral[200]};
`;

export const DefaultContent = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  padding: 5rem 1.25rem;

  @media ${mediaQueries.mobileOrTablet} {
    padding: 5rem 1rem;
  }
`;

export const DefaultContentSection = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  border-radius: 12px;
  height: 20.25rem;
  width: 18.25rem;

  @media ${mediaQueries.mobileOrTablet} {
    width: 100%;

    &:not(:first-child) {
      display: none;
    }
  }
`;
